var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHat1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50mm",
    height: 142.983,
    viewBox: "0 0 50 37.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -259.169)"
  }, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 0.035,
    transform: "scale(-2.88397 2.88397) rotate(-16.184 -437.084 1427.505)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3a221f",
    d: "M353.555 271.277c0 1.604-4.023 2.905-8.986 2.905-4.963 0-8.986-1.3-8.986-2.905 0-1.605 4.023-2.906 8.986-2.906 4.963 0 8.986 1.3 8.986 2.906"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#614540",
    d: "M351.113 270.885c0 .931-2.93 1.686-6.544 1.686-3.615 0-6.544-.755-6.544-1.686 0-.698.825-6.387 3.174-8.366.783-.66 2.466.556 3.37.556.677 0 2.071-1.15 2.686-.752 2.664 1.73 3.858 7.805 3.858 8.562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b8f96",
    d: "M344.569 270.226c-2.971 0-5.479-.51-6.278-1.208-.185.935-.266 1.647-.266 1.867 0 .931 2.93 1.686 6.544 1.686 3.614 0 6.544-.755 6.544-1.686 0-.224-.105-.915-.321-1.821-.855.674-3.318 1.162-6.223 1.162"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat1);
export default __webpack_public_path__ + "static/media/hat1.ab13ef5017016fec67b880b9667bf8dd.svg";
export { ForwardRef as ReactComponent };